import unescape from 'helpers/unescape'

angular
  .module 'gym.components'
  .directive 'stripeServiceAgreement', ->
    restrict: 'EA'
    template: require('templates/components/waivers/stripe_service_agreement.html.slim')
    controller: ($scope, $rootScope) ->
      $scope.gymName = $rootScope.gym?.name || unescape(window.DATA.gym_name)
